import { useState, useCallback } from 'react';
import { API_URL } from '../constants/api';

export function useAuth(deviceId) {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authEmail, setAuthEmail] = useState('');
  const [authError, setAuthError] = useState('');
  const [authLoading, setAuthLoading] = useState(false);
  const [authEmailSent, setAuthEmailSent] = useState(false);

  const sendMagicLink = useCallback(async () => {
    setAuthError('');
    setAuthLoading(true);

    if (!authEmail || !authEmail.includes('@')) {
      setAuthError('Please enter a valid email address');
      setAuthLoading(false);
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/auth/send-magic-link`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          email: authEmail,
          deviceId
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setAuthEmailSent(true);
      } else {
        setAuthError(data.error || 'Failed to send magic link');
      }
    } catch (error) {
      console.error('Magic link error:', error);
      setAuthError('Unable to send magic link. Please try again.');
    } finally {
      setAuthLoading(false);
    }
  }, [authEmail, deviceId]);

  const openAuthModal = useCallback(() => {
    setShowAuthModal(true);
    setAuthEmailSent(false);
    setAuthEmail('');
    setAuthError('');
  }, []);

  const closeAuthModal = useCallback(() => {
    setShowAuthModal(false);
    setAuthEmail('');
    setAuthError('');
    setAuthEmailSent(false);
  }, []);

  return {
    showAuthModal,
    setShowAuthModal,
    authEmail,
    setAuthEmail,
    authError,
    setAuthError,
    authLoading,
    authEmailSent,
    setAuthEmailSent,
    sendMagicLink,
    openAuthModal,
    closeAuthModal,
  };
}
